import { BooleanField, Field } from '@src/permitField/PermitFields';
import * as TractorDimensionsPermitFields from '@src/permitField/TractorDimensionsFields';
import * as TractorInformationPermitFields from '@src/permitField/TractorInformationFields';
import * as TractorLicensePermitFields from '@src/permitField/TractorLicenseFields';
import * as TractorOwnerPermitFields from '@src/permitField/TractorOwnerFields';
import { JurisdictionField } from '@src/permitTypesManager/permitTypeSections/PermitDefinitionFields';
import * as yup from 'yup';

export class TractorUnitNumberField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorUnitNumberField.fieldName;
}

export class TractorMakeField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorMakeField.fieldName;
}

export class TractorVINField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorVINField.fieldName;
}

export class TractorYearField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorYearField.fieldName;
}

export class TractorAxleCountField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorAxleCountField.fieldName;
}

export class TractorLicensePlateNumberField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorLicensePlateNumberField.fieldName;
}

export class TractorLicensePlateStateField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorLicensePlateStateField.fieldName;
}

export class TractorModelNumberField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorModelNumberField.fieldName;
}

export class TractorTypeField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorTypeField.fieldName;
}

export class TractorFuelTypeField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorFuelTypeField.fieldName;
}

export class TractorBodyStyleField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.TractorBodyStyleField.fieldName;
}

export class VehicleOfSpecialDesignField extends BooleanField {
  public static fieldName: string =
    TractorInformationPermitFields.VehicleOfSpecialDesignField.fieldName;
}

export class TractorLicenseEffectiveDateField extends BooleanField {
  public static fieldName: string =
    TractorLicensePermitFields.TractorLicenseEffectiveDateField.fieldName;
}

export class TractorLicenseExpirationDateField extends BooleanField {
  public static fieldName: string =
    TractorLicensePermitFields.TractorLicenseExpirationDateField.fieldName;
}
export class TractorLicensePlateTypeField extends BooleanField {
  public static fieldName: string =
    TractorLicensePermitFields.TractorLicensePlateTypeField.fieldName;
}

export class TractorLicensePlateYearField extends BooleanField {
  public static fieldName: string =
    TractorLicensePermitFields.TractorLicensePlateYearField.fieldName;
}

export class TractorLicenseIsApportionedPlateField extends BooleanField {
  public static fieldName: string =
    TractorLicensePermitFields.TractorLicenseIsApportionedPlateField.fieldName;
}

export class TractorIsLeasedField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.TractorIsLeasedField.fieldName;
}

export class TractorOwnerNameField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.TractorOwnerNameField.fieldName;
}

export class OwnerCompanyNameField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.OwnerCompanyNameField.fieldName;
}

export class USDOTNumberOfOwningCompanyField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.USDOTNumberOfOwningCompanyField.fieldName;
}

export class OwnerAddressField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.OwnerAddressField.fieldName;
}

export class OwnerCityField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.OwnerCityField.fieldName;
}

export class OwnerStateField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.OwnerStateField.fieldName;
}

export class OwnerZipCodeField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.OwnerZipCodeField.fieldName;
}

export class OwnerPhoneField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.OwnerPhoneField.fieldName;
}

export class OwnerEmailField extends BooleanField {
  public static fieldName: string =
    TractorOwnerPermitFields.OwnerEmailField.fieldName;
}

export class TractorHeightField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorHeightField.fieldName;
}

export class TractorWidthField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorWidthField.fieldName;
}

export class TractorLengthField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorLengthField.fieldName;
}

export class TractorGroundHeightField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorGroundHeightField.fieldName;
}

export class TractorWheelBaseField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorWheelBaseField.fieldName;
}

export class TractorUnladenWeightField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorUnladenWeightField.fieldName;
}

export class TractorActualWeightField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorActualWeightField.fieldName;
}

export class TractorLegalWeightField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorLegalWeight.fieldName;
}

export class TractorOuterBridgeLengthField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorOuterBridgeLengthField.fieldName;
}

export class TractorGVWField extends BooleanField {
  public static fieldName: string =
    TractorDimensionsPermitFields.TractorGVWField.fieldName;
}

export class FloridaTractorVehicleConfigurationField extends Field {
  public static fieldName: string =
    TractorInformationPermitFields.TractorFloridaVehicleConfigurationField
      .fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'FL',
      then: (schema) => schema.required(),
    });
}

export class OntarioTractorVehicleTypeField extends Field {
  public static fieldName: string =
    TractorInformationPermitFields.TractorOntarioVehicleTypeField.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'ON',
      then: (schema) => schema.required(),
    });
}
